import { useTranslation } from 'react-i18next';
import { FaRegThumbsUp } from 'react-icons/fa';
import { useDraftEntryStore } from '@/pages/Schedule/stores';
import { Icon } from '@/ui';
import { useEntryModalContext } from '../contexts';
import { HeaderButton } from './HeaderButton';

export const RsvpButton = () => {
  const { toggleSidebar, activeSidebarPanel } = useEntryModalContext();
  const { t } = useTranslation('entryModal', { keyPrefix: 'rsvps_panel' });
  const draftEntry = useDraftEntryStore((state) => state.draftEntry);

  return (
    <HeaderButton
      isActive={activeSidebarPanel === 'rsvps'}
      isHighlighted={draftEntry?.rsvpSettings.enabled}
      leftIcon={<Icon as={FaRegThumbsUp} />}
      onClick={() => toggleSidebar('rsvps')}
    >
      {t('button_label')}
    </HeaderButton>
  );
};
